/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "calendar-inline-b52cd7aa--sprite",
  "use": "calendar-inline-b52cd7aa--sprite-usage",
  "viewBox": "0 0 18 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 17\" id=\"calendar-inline-b52cd7aa--sprite\"><path d=\"M426,399.333v8a2.006,2.006,0,0,0,2,2h14a2.006,2.006,0,0,0,2-2v-8a1,1,0,0,0-1-1H427A1,1,0,0,0,426,399.333Zm16,7a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1v-2a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1Z\" transform=\"translate(-426 -392.333)\" fill=\"currentColor\" /><path d=\"M444,395.333v1a1,1,0,0,1-1,1H427a1,1,0,0,1-1-1v-1a1,1,0,0,1,1-1h3.5v-1.5a.5.5,0,0,1,1,0v1.5h7v-1.5a.5.5,0,0,1,1,0v1.5H443A1,1,0,0,1,444,395.333Z\" transform=\"translate(-426 -392.333)\" fill=\"currentColor\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
